<template>
	<v-card :loading="loading">
		<v-card-title>날짜별 조회수</v-card-title>
		<v-divider />

		<v-card-text class="pt-3">
			<form class="search relative">
				<select v-model="params.year" @change="load">
					<option
						v-for="year in _.range(current_year, 2019, -1)"
						:key="year"
						:value="year"
					>
						{{ year }}
					</option>
				</select>
				년

				<select v-model="params.month" @change="load">
					<option value="" selected>선택</option>
					<option
						v-for="month in _.range(1, 13)"
						:key="month"
						:value="month"
					>
						{{ month }}
					</option>
				</select>
				월

				<div class="absolute-right">
					<v-btn @click="csv" x-small>csv</v-btn>
				</div>
			</form>

			<table class="detail">
				<tr>
					<th>날짜</th>
					<th>일 조회수</th>
					<th>누적 조회수</th>
				</tr>

				<tr></tr>

				<tr v-for="row in rows" :key="row.date">
					<td style="text-align: center">{{ row.date }}</td>
					<td style="text-align: center">
						{{ row.hit_count.toLocaleString() }}
					</td>
					<td style="text-align: center">
						{{ row.hit_count_sum.toLocaleString() }}
					</td>
				</tr>

				<tr v-if="!rows.length">
					<td style="text-align: center" colspan="3">
						데이터가 없습니다.
					</td>
				</tr>
			</table>
		</v-card-text>
	</v-card>
</template>

<script>
	import _ from 'lodash';
	import moment from 'moment';
	import Util from '@/util';

	export default {
		props: {
			id: { type: Number, default: null },
		},

		data() {
			return {
				loading: false,
				current_year: moment().utc(9).year(),
				params: {
					year: moment().utc(9).year(),
				},
				rows: [],
			};
		},

		created() {
			this.load();
		},

		methods: {
			async load() {
				this.loading = true;
				const { data } = await this.$axiosAdminJS.get(
					`/product/${this.id}/view-log`
				);
				let sum = 0;
				this.rows = _.each(data.rows, row => {
					sum += row.hit_count;
					row.hit_count_sum = sum;
				})
					.reverse()
					.filter(row => {
						if (this.params.month) {
							return (
								0 ==
								row.date.indexOf(
									this.params.year +
										'-' +
										_.padStart(this.params.month, 2, '0')
								)
							);
						} else {
							return 0 == row.date.indexOf(this.params.year);
						}
					});

				this.loading = false;
			},

			async csv() {
				const name = `${this.id}_${this.params.year}_날짜별조회수`;
				Util.getCsv(
					[this.rows.map(row => _.values(row))],
					undefined,
					[['날짜', '일 조회수', '누적 조회수']],
					name
				);
				this.loading = false;
			},
		},
	};
</script>

<style lang="scss" scoped>
	TABLE.detail {
		margin-top: 10px;
	}
</style>
